import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CreateMakePayload, CreateMakeResponse } from '../api/vehicles';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class VehicleMakesService {
    private baseUrl: string = '/admin/vehicle-makes';

    constructor(private http: HttpClient) {}

    createVehicleMake(
        payload: CreateMakePayload
    ): Observable<CreateMakeResponse> {
        return this.http.post<CreateMakeResponse>(this.baseUrl, payload);
    }

    getMakeById(id: string): Observable<CreateMakeResponse> {
        return this.http.get<CreateMakeResponse>(
            this.baseUrl.concat('/').concat(id)
        );
    }

    getAllMakes(): Observable<CreateMakeResponse[]>{
        return this.http.get<CreateMakeResponse[]>(this.baseUrl);
    }
}
